export default [
  '$0-$1M',
  '$1M-$10M',
  '$10M-$50M',
  '$50M-$100M',
  '$100M-$250M',
  '$250M-$500M',
  '$500M-$1B',
  '$1B-$10B',
  '$10B+',
]



// WEBPACK FOOTER //
// ./src/scripts/constants/ClearbitRevenueRanges.js